import { useOutletContext } from "react-router-dom";
import useTitleResults from "../results/useTitleResults.ts";
import useContentResults from "../results/useContentResults.ts";

export interface SearchOutletContext {
  query: string;
  // store/explore/licensed title search results
  titleResults: ReturnType<typeof useTitleResults>;
  // content results
  contentResults: ReturnType<typeof useContentResults>;
  // used to stop empty titles flashing when redirecting to content
  waitForTabFlip: boolean;
}

export default function useSearchOutletContext() {
  return useOutletContext<SearchOutletContext>();
}
